import * as React from "react";
import { DeviceType, SessionType } from "../../misc/api/apiTypes";
import { Study } from "webportalclient";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

interface VisitScheduleContextState {
    study: Study;
    deviceTypes: DeviceType[];
    sessionTypes: SessionType[];
}

const VisitScheduleContext = React.createContext<VisitScheduleContextState | undefined>(undefined);

interface CurrentStudyConfigurationContextProviderProps {
    study: Study;
    children: React.ReactNode;
}

export const VisitScheduleContextProvider = ({ study, children }: CurrentStudyConfigurationContextProviderProps) => {
    const [deviceTypes, setDeviceTypes] = React.useState([]);
    const [sessionTypes, setSessionTypes] = React.useState([]);
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getData = async () => {
            if (study) {
                const deviceTypesResult = await legacyClient.getStudyDeviceTypes(study.id);
                setDeviceTypes(deviceTypesResult);

                const sessionTypesResult = await legacyClient.getStudySessionTypes(study.id);
                setSessionTypes(sessionTypesResult);
            }
        }

        getData();
    }, [study]);

    return (
        <VisitScheduleContext.Provider value={{ study: study, deviceTypes: deviceTypes, sessionTypes: sessionTypes }}>
            {children}
        </VisitScheduleContext.Provider>
    );
}

export const useVisitScheduleContext = (): VisitScheduleContextState => {
    const context = React.useContext(VisitScheduleContext);
    if (context === undefined) {
        throw new Error('useVisitScheduleContext must be used within a VisitScheduleContext Provider')
    }

    return context;
}
